import { WprBaseScopeInfo } from './WprBaseScopeInfo';

/**
 * グローバルスコープ基本情報
 */
export abstract class WprBaseGlobalScopeInfo extends WprBaseScopeInfo {
	// private 変数  ------------------------------------------------------------
	private m_ScopeInfoList		= new Array();		// スコープ情報リスト
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(name: string) {
		super(name, true);
	}
	// --------------------------------------------------------------------------

	// public メソッド  ---------------------------------------------------------
	/**
	 * スコープマップ設定処理
	 * @param map スコープマップ
	 */
	public setScopeMap(map: Map<string, WprBaseScopeInfo>) {
		map.forEach((vinfo, key, minfo) => {
			if (this !== vinfo)
				this.m_ScopeInfoList.push(vinfo);
		});
	}
	// --------------------------------------------------------------------------
}
